import { Region } from "backbone.marionette";
import raf from "raf";

class ContentRegion extends Region {

    attachHtml (view) {
        raf(_ => {
            this.$el.slideUp(300, _ => {
                this.$el.empty().append(view.el).slideDown(300);
            });
        });
    }

    /**
     * Set the loading state of the content region
     *
     * @param state {Boolean} Whether or not the loader should be set.
     */
    set loading (state) {
        this._loading = state;
        this.$el.toggleClass("content-loading", state);
    }

    /**
     * Set the loading state of the content region
     *
     * @returns {Boolean} Whether or not the loader is set.
     */
    get loading () {
        return this._loading;
    }

}

export default ContentRegion;


// WEBPACK FOOTER //
// ./public/kernel/abstraction/content-region.js